import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import ColoredCell from '@Components/Results/substances/tables/cells/ColoredCell';

function PaureusCell({ value }) {
  return <ColoredCell value={value}>{(style) => <InnerHTML tag="div" className="px-data" style={style} html={value} />}</ColoredCell>;
}

PaureusCell.propTypes = {
  value: PropTypes.string.isRequired,
};

export default React.memo(PaureusCell);
